/* eslint-disable @typescript-eslint/no-explicit-any */
// TODO: This file was automatically migrated to TypeScript by `dev typescript migrate`.
//  The eslint disable comment above should be removed and the resulting errors fixed.
import reactUpdate from 'immutability-helper';
import React from 'react';

import ChooseProteinAlignmentPane from 'analyses/protein-alignment/ChooseProteinAlignmentPane';
import * as MapsConstants from 'constants/MapsConstants';
import Modal from 'ui-library/modals/Modal';

import ProteinAlignmentActions from './ProteinAlignmentActions';

const {ALIGNMENT_TYPE} = MapsConstants;

interface Props {
  onRequestClose: (...args: Array<any>) => any;
  alignment: any;
}

type State = any;

class ProteinRealignModal extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    const proteinSpecifiers = props.alignment.rows
      .filter((row: any) => row.originalProteinId)
      .map((row: any) => ({
        name: row.name,
        id: row.originalProteinId,

        // This is ignored by ChooseProteinAlignmentPane since we disallow modifying the template
        // anyway.
        canBeTemplate: false,
      }));

    this.state = {
      proteinSpecifiers,
    };
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  _handleAddProteinSpecifier = (proteinSpecifier: any) => {
    this.setState({
      proteinSpecifiers: reactUpdate(this.state.proteinSpecifiers, {$push: [proteinSpecifier]}),
    });
  };

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  _handleRemoveProteinAt = (index: any) => {
    this.setState({
      proteinSpecifiers: reactUpdate(this.state.proteinSpecifiers, {$splice: [[index, 1]]}),
    });
  };

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  _handleRealign = () => {
    let specifiers;
    if (this._isTemplate()) {
      // The first protein specifier is the template if this is for a template alignment, so remove
      // it, since that's always implicit for realign.
      specifiers = this.state.proteinSpecifiers.slice(1);
    } else {
      specifiers = this.state.proteinSpecifiers;
    }
    ProteinAlignmentActions.realign({
      alignment: this.props.alignment,
      proteinSpecifiers: specifiers,
    });
    this.props.onRequestClose();
  };

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  _isTemplate = () => this.props.alignment.alignmentType === ALIGNMENT_TYPE.TEMPLATE;

  render(): JSX.Element {
    return (
      <Modal
        enableRedesign={false}
        title="Realign"
        onRequestClose={this.props.onRequestClose}
        buttons={[
          {
            text: 'Realign',
            onClick: this._handleRealign,
            disabled: this.state.proteinSpecifiers.length <= 1,
            style: 'primary',
            key: 'download',
          },
          {
            text: 'Cancel',
            cancel: true,
            key: 'cancel',
          },
        ]}
      >
        <ChooseProteinAlignmentPane
          proteinSpecifiers={this.state.proteinSpecifiers}
          templateProteinIndex={this._isTemplate() ? 0 : null}
          onAddProteinSpecifier={this._handleAddProteinSpecifier}
          onRemoveProteinAt={this._handleRemoveProteinAt}
          onSetTemplateProteinAt={() => {}}
          allowSetTemplate={false}
        />
      </Modal>
    );
  }
}

export default ProteinRealignModal;
